'use strict';

/*global app*/
/*global isEmpty*/
/*global btUnknown*/
/*global btBatch*/
/*global btArticle*/
/*global btLocation*/
/*global btHandlingUnit*/
/*global btConsolidationBox*/
/*global btConsolidationLocation*/
/*global btConsolidationArticle*/
/*global invokeCallback*/
/*global resSuccess*/
/*global resError*/

function BarcodeService() {
  this.$container = null;

  this.cache = {};

  this.init();
}

BarcodeService.prototype = $.extend({}, {
  constructor: 'BarcodeService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  saveToCache: function saveToCache(barcode, data) {
    var _this = this;

    barcode = barcode.toLowerCase();

    _this.cache[barcode] = data;

    return _this;
  },

  getFromCache: function getFromCache(barcode) {
    var _this = this;

    barcode = barcode.toLowerCase();

    if (barcode in _this.cache) {
      return _this.cache[barcode];
    }

    return null;
  },

  doFind: function doFind(action, data, callback) {
    var _this = this;

    var barcode = data.Barcode;
    var cacheData = _this.getFromCache(barcode);
    if (cacheData) {
      invokeCallback(callback, resSuccess, cacheData);
    } else {
      app.getFormation(action, data, function (res) {
        if (res.msg === 'SUCCESS') {
          if (res.data.BarcodeType !== btUnknown) {
            _this.saveToCache(barcode, res.data);
          }

          invokeCallback(callback, resSuccess, res.data);
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    }

    return _this;
  },

  find: function find(barcode, param, callback) {
    var _this = this;

    return _this.doFind('barcode:find', { Barcode: barcode, Param: param }, callback);
  },

  findBatch: function findBatch(barcode, callback) {
    var _this = this;

    return _this.doFind('barcode:find_batch', { Barcode: barcode }, function (res, resData) {
      if (resData.BarcodeType === btBatch) {
        invokeCallback(callback, res, resData);
      } else {
        invokeCallback(callback, resError);
      }
    });
  },

  findArticle: function findArticle(barcode, tradingPartnerId, callback) {
    var _this = this;

    return _this.doFind('barcode:find_article', { Barcode: barcode, TradingPartnerId: tradingPartnerId }, function (res, resData) {
      if (resData.BarcodeType === btArticle) {
        invokeCallback(callback, res, resData);
      } else {
        invokeCallback(callback, resError);
      }
    });
  },

  findLocation: function findLocation(barcode, warehouseId, callback) {
    var _this = this;

    return _this.doFind('barcode:find_location', { Barcode: barcode, WarehouseId: warehouseId }, function (res, resData) {
      if (resData.BarcodeType === btLocation) {
        invokeCallback(callback, res, resData);
      } else {
        invokeCallback(callback, resError);
      }
    });
  },

  findHandlingUnit: function findHandlingUnit(barcode, callback) {
    var _this = this;

    return _this.doFind('barcode:find_handling_unit', { Barcode: barcode }, function (res, resData) {
      if (resData.BarcodeType === btHandlingUnit) {
        invokeCallback(callback, res, resData);
      } else {
        invokeCallback(callback, resError);
      }
    });
  },

  findConsolidationBox: function findConsolidationBox(barcode, tradingPartnerId, callback) {
    var _this = this;

    return _this.doFind('barcode:find_consolidation_box', { Barcode: barcode, TradingPartnerId: tradingPartnerId }, function (res, resData) {
      if (resData.BarcodeType === btConsolidationBox) {
        invokeCallback(callback, res, resData);
      } else {
        invokeCallback(callback, resError);
      }
    });
  },

  findConsolidationLocation: function findConsolidationLocation(barcode, callback) {
    var _this = this;

    return _this.doFind('barcode:find_consolidation_location', { Barcode: barcode }, function (res, resData) {
      if (resData.BarcodeType === btConsolidationLocation) {
        invokeCallback(callback, res, resData);
      } else {
        invokeCallback(callback, resError);
      }
    });
  },

  findConsolidationArticle: function findConsolidationArticle(barcode, consolidationBatchRID, callback) {
    var _this = this;

    return _this.doFind('barcode:find_consolidation_article', { Barcode: barcode, ConsolidationBatchRID: consolidationBatchRID }, function (res, resData) {
      if (resData.BarcodeType === btConsolidationArticle) {
        invokeCallback(callback, res, resData);
      } else {
        invokeCallback(callback, resError);
      }
    });
  },

  scanBarcode: function scanBarcode(title, callback) {
    var _this = this;

    app.getValueWithRes({ content: title }, callback);

    return _this;
  },

  scanAndFind: function scanAndFind(title, param, callback) {
    var _this = this;

    _this.scanBarcode(title, function (res, barcode) {
      if (res !== resSuccess) {
        return invokeCallback(callback, res);
      }

      _this.find(barcode, param, callback);
    });

    return _this;
  },

  scanAndFindBarcode: function scanAndFindBarcode(type, title, param, callback) {
    var _this = this;

    if (isEmpty(title)) {
      switch (type) {
        case btBatch: title = 'Načtěte štítek <strong>šarže</strong>'; break;
        case btArticle: title = 'Načtěte štítek <strong>zboží</strong>'; break;
        case btLocation: title = 'Načtěte štítek <strong>umístění</strong>'; break;
        case btHandlingUnit: title = 'Načtěte štítek <strong>manipulační jednotky</strong>'; break;
        case btConsolidationBox: title = 'Načtěte <strong>KLT box</strong>'; break;
        case btConsolidationLocation: title = 'Načtěte <strong>umístění na konsolidaci</strong>'; break;
        case btConsolidationArticle: title = 'Načtěte <strong>zboží na konsolidaci</strong>'; break;
      }
    }

    _this.scanBarcode(title, function (res, barcode) {
      if (res !== resSuccess) {
        return invokeCallback(callback, res);
      }

      switch (type) {
        case btBatch : {
          _this.findBatch(barcode, param, callback);
        }

        break;
        case btArticle : {
          _this.findArticle(barcode, param, callback);
        }

        break;
        case btLocation : {
          _this.findLocation(barcode, param, callback);
        }

        break;
        case btHandlingUnit : {
          _this.findHandlingUnit(barcode, callback);
        }

        break;
        case btConsolidationBox : {
          _this.findConsolidationBox(barcode, param, callback);
        }

        break;
        case btConsolidationLocation : {
          _this.findConsolidationLocation(barcode, callback);
        }

        break;
        case btConsolidationArticle : {
          _this.findConsolidationArticle(barcode, param, callback);
        }
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('body');

    _this.registerCallbacks();

    return _this;
  }
});
